import React from 'react';
import PropTypes from 'prop-types';

const buttonStyle = {
  margin: 0,
  lineHeight: 2,
  width: '50%',
  height: 38
};

const TokenFilterButton = ({action, label}) => (
  <button className="btn red-ghost-btn" style={buttonStyle} onClick={action}>
    {label}
  </button>
);

TokenFilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TokenFilterButton;



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/token-filter-button.jsx